// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"PremiumChartCTA_ctaButton__D1SLt","ctaTitle":"PremiumChartCTA_ctaTitle__8taej","ctaBody":"PremiumChartCTA_ctaBody__vI8wR"};